if (!customElements.get('landing-trust-features')) {
  class LandingTrustFeatures extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.track = this.querySelector('[data-trust-track]');
      this.items = Array.from(this.querySelectorAll('[data-trust-item]'));
      this.previousButton = this.querySelector('[data-trust-previous]');
      this.nextButton = this.querySelector('[data-trust-next]');

      if (!this.track || this.items.length === 0 || !this.previousButton || !this.nextButton) return;

      this.isInitialized = true;
      this.animationFrame = null;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.track);
      }

      this.updateControls();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.track.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.resizeObserver?.disconnect();

      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.isInitialized = false;
    }

    handleScroll() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.animationFrame = requestAnimationFrame(() => this.updateControls());
    }

    handleResize() {
      this.updateControls();
    }

    currentIndex() {
      const currentPosition = this.track.scrollLeft;

      return this.items.reduce((closestIndex, item, index) => {
        const closestDistance = Math.abs(this.items[closestIndex].offsetLeft - currentPosition);
        const itemDistance = Math.abs(item.offsetLeft - currentPosition);
        return itemDistance < closestDistance ? index : closestIndex;
      }, 0);
    }

    move(direction) {
      const targetIndex = Math.min(Math.max(this.currentIndex() + direction, 0), this.items.length - 1);
      const trackPadding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollTo({
        left: this.items[targetIndex].offsetLeft - trackPadding,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    updateControls() {
      const maximumScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      this.previousButton.disabled = this.track.scrollLeft <= 1;
      this.nextButton.disabled = maximumScroll <= 1 || this.track.scrollLeft >= maximumScroll - 1;
    }
  }

  customElements.define('landing-trust-features', LandingTrustFeatures);
}
